var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bannerPath)?_c('div',[_c('a',{attrs:{"href":_vm.linkURL,"target":"_blank","rel":"noopener"}},[_c('img',{attrs:{"src":_vm.bannerPath}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }